'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_DATA_RELOADED = exports.RELOAD_USER_SPECIFIC_DATA = exports.SET_SESSION_STORAGE_VALUE = exports.SET_LOCAL_STORAGE_VALUE = exports.RESET_LD_CLIENT_ID = exports.SET_LD_CLIENT_ID = exports.BOOTSTRAP_SUCCESS = exports.BOOTSTRAP = undefined;

var _constants = require('./constants');

var BOOTSTRAP = exports.BOOTSTRAP = _constants.NAME + '/BOOTSTRAP';

var BOOTSTRAP_SUCCESS = exports.BOOTSTRAP_SUCCESS = _constants.NAME + '/BOOTSTRAP_SUCCESS';

var SET_LD_CLIENT_ID = exports.SET_LD_CLIENT_ID = _constants.NAME + '/SET_LD_CLIENT_ID';

var RESET_LD_CLIENT_ID = exports.RESET_LD_CLIENT_ID = _constants.NAME + '/RESET_LD_CLIENT_ID';

var SET_LOCAL_STORAGE_VALUE = exports.SET_LOCAL_STORAGE_VALUE = _constants.NAME + '/SET_LOCAL_STORAGE_VALUE';

var SET_SESSION_STORAGE_VALUE = exports.SET_SESSION_STORAGE_VALUE = _constants.NAME + '/SET_SESSION_STORAGE_VALUE';

var RELOAD_USER_SPECIFIC_DATA = exports.RELOAD_USER_SPECIFIC_DATA = _constants.NAME + '/RELOAD_USER_SPECIFIC_DATA';

var USER_DATA_RELOADED = exports.USER_DATA_RELOADED = _constants.NAME + '/USER_DATA_RELOADED';